// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MarginSolution-module--wrapper--2Zwv0"};